import { USER } from './constantsBackOffice'

export  const sortListDashboard = (data, type = 'default') => {
  if (type === USER) {
    return data.sort((a,b) => `${a.last_name} ${a.first_name}`.localeCompare(`${b.last_name} ${b.first_name}`, { sensitivity: 'base' }))
  } else {
    return data.sort((a,b) => a.name.localeCompare(b.name, { sensitivity: 'base' }))
  }
}